var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCopiar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.6,7.8l-9.8,0c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4l9.8,0c0.8,0,1.4-0.6,1.4-1.4C27,8.4,26.4,7.8,25.6,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,14.7c0-0.8-0.6-1.4-1.4-1.4l-9.8,0c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4l9.8,0C26.4,16.1,27,15.5,27,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9,18.8c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4l4.2,0c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4L15.9,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,19.1c0.8,0,1.4-0.6,1.4-1.4l0-11.8c0-3-2.5-5.5-5.5-5.5l-12.7,0c-3,0-5.5,2.5-5.5,5.5c-3,0-5.5,2.5-5.5,5.5l0,18.7 c0,3,2.5,5.5,5.5,5.5l13.4,0c3,0,5.5-2.5,5.5-5.5v0c2.7-0.3,4.8-2.7,4.8-5.5c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 c0,1.5-1.2,2.8-2.8,2.8l-12.7,0h0c-0.7,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.2-0.8-1.9l0-18.7c0-1.5,1.2-2.8,2.8-2.8l12.7,0 c1.5,0,2.8,1.2,2.8,2.8l0,11.8C29.8,18.5,30.5,19.1,31.2,19.1z M14.4,30.1L14.4,30.1l10.6,0c0,1.5-1.2,2.8-2.8,2.8l-13.4,0 c-1.5,0-2.8-1.2-2.8-2.8l0-18.7c0-1.5,1.2-2.8,2.8-2.8l0,16c0,1.5,0.6,2.9,1.6,3.9C11.6,29.5,12.9,30.1,14.4,30.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopiar01);
export default __webpack_public_path__ + "static/media/ico-copiar-01.9b946267a701cabe4d38a784d80f20d8.svg";
export { ForwardRef as ReactComponent };